import React from 'react'
import Walmart from '../../assets/walmart.png'
import Microsoft from '../../assets/microsoft.png'
import Adobe from '../../assets/adobe.png'
import Facebook from '../../assets/facebook.png'

const Clients = () => {
  return (
    <div id="clients">
        <h1 className="contactPageTitle">My Clients</h1>
        <p className="clientDesc">
        I have had the opportunity to work with a diverse group of companies.
        Some of the notable companies I have worked with includes.
        </p>
        <div className="clientImgs">
        <img src={Walmart} alt="Clients" className="clientImg" />
        <img src={Adobe} alt="Clients" className="clientImg" />
        <img src={Microsoft} alt="Clients" className="clientImg" />
        <img src={Facebook} alt="Clients" className="clientImg" />
        </div>
    </div>
  )
}

export default Clients